import { useEffect, useState } from "react";
import MDSelect from "components/MDSelect";
import { get } from "utils/WebService";

// Marcações especiais de uma ficha ou contrato, com a regra de carteira (MarcacaoEspecialService no backend): só oferece
// as que valem para a carteira (as universais e as dessa carteira) e que o usuário vê. As que o registro já tem continuam
// aparecendo (dá para tirar, mesmo que hoje não valham mais para a carteira); as que o usuário nem vê (de carteiras de
// outras equipes) ficam gravadas sem aparecer. Sem carteira, oferece todas as que ele vê (o backend confere ao salvar).
// alvos: 1 Ficha, 2 Contrato, 3 Ambos.
export default function SeletorMarcacoes({ carteira, alvos, value, onChange, isDisabled, name, placeholder }) {
  const [todas, setTodas] = useState([]);
  const chaveAlvos = (alvos || []).join(",");

  useEffect(() => {
    let ativo = true;
    const url = carteira ? `/marcacoes?carteira=${encodeURIComponent(carteira)}` : "/marcacoes";
    get(url)
      .then((res) => {
        if (!ativo) return;
        const lista = res?.list || res?.data || (Array.isArray(res) ? res : []);
        setTodas(lista.filter((m) => (alvos || []).includes(m.cvAlvo)));
      })
      .catch(() => ativo && setTodas([]));
    return () => {
      ativo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carteira, chaveAlvos]);

  const ids = value || [];
  const opcoes = todas.filter((m) => m.valeParaCarteira !== false);
  const escolhidas = todas.filter((m) => ids.includes(m.cvId));
  const ocultas = ids.filter((id) => !todas.some((m) => m.cvId === id));

  return (
    <MDSelect
      isMulti={true}
      getOptionValue={(option) => option.cvId}
      getOptionLabel={(option) => (option.valeParaCarteira === false ? `${option.ccNome} (não vale para esta carteira)` : option.ccNome)}
      name={name}
      placeholder={placeholder || "Selecione as marcações..."}
      value={escolhidas}
      options={opcoes}
      onChange={(selected) => onChange([...(selected ? selected.map((s) => s.cvId) : []), ...ocultas])}
      isDisabled={isDisabled}
    />
  );
}
